import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleAddStudentSelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#56A" opacity={0.88} cx={28} cy={28} r={28} />
        <path
          d="M28 29c2.936 0 4.558.398 5.69.795 2.796.981 5.81 3.009 5.81 7.442 0 1.126-.805 1.963-2.212 2.424-1.65.541-5.754.69-8.938.7h-.7c-3.184-.01-7.287-.159-8.938-.7-1.407-.461-2.212-1.298-2.212-2.424 0-4.433 3.014-6.46 5.81-7.442 1.085-.38 2.62-.762 5.33-.793L28 29zm0-14.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13z"
          fill="#FFF"
        />
        <circle fill="#8F9DD6" cx={38} cy={36} r={8} />
        <path
          d="M38.8 32c.11 0 .2.09.2.2V35h2.8c.11 0 .2.09.2.2v1.6a.2.2 0 01-.2.2H39v2.8a.2.2 0 01-.2.2h-1.6a.2.2 0 01-.2-.2V37h-2.8a.2.2 0 01-.2-.2v-1.6c0-.11.09-.2.2-.2H37v-2.8c0-.11.09-.2.2-.2h1.6z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

SvgPicCircleAddStudentSelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleAddStudentSelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleAddStudentSelected svgRef={ref} {...props} />
));
export default ForwardRef;
